import { LoaderScreen } from '@/components/Elements';
import { Layout } from '@/components/Layout';
import { useThemes } from '@/features/theme/api/getThemes';
import { categoryAllIconImage } from '@/features/theme/assets/images';
import { ThemeSearchLink } from '@/features/theme/components/ThemeSearchLink';
import { ThemeCategoryCard } from '@/features/theme/components/ThemeCategoryCard';
import { THEME_CATEGORIES } from '@/features/theme/constants';
import { Theme } from '@/features/theme/types';
import { useTranslation } from 'react-i18next';
import { ConnectDotsThemesMenu } from '@/features/connect-dots/pages/ConnectDotsThemesMenu';

const themesFilterByCategory = (themes: Theme[], category: string): Theme[] => {
  return themes.filter((theme) => theme.category === category);
};

export const ThemesPage = () => {
  const { t } = useTranslation();
  const themesQuery = useThemes();

  if (themesQuery.isLoading) {
    return <LoaderScreen />;
  }

  return (
    <Layout backgroundClassName="bg-themes bg-cover bg-fixed bg-center">
      <div>
        <div className="flex items-center justify-center pb-2 pt-4 md:h-full">
          <div className="w-full max-w-6xl rounded-tr-3xl bg-white/60 backdrop-blur-xl">
            <h2 className="px-8 pb-2 pt-4 text-2xl font-semibold text-black shadow-xl shadow-white/20">
              {t('テーマで検索')}
            </h2>

            <div className="px-4 pb-4 shadow-xl shadow-white/20">
              {themesQuery.data && themesQuery.data.length > 0 ? (
                <>
                  {/* テーマカテゴリのグリッド */}
                  <div className="my-4 grid grid-cols-2 gap-4 lg:grid-cols-4">
                    {THEME_CATEGORIES.map((category) => {
                      const themes = themesFilterByCategory(
                        themesQuery.data,
                        category.code
                      );

                      if (themes.length === 0) return null;

                      return (
                        <ThemeCategoryCard
                          key={category.code}
                          title={t(category.title)}
                          iconImage={category.iconImage}
                          coverImage={category.coverImage}
                          themes={themes}
                        />
                      );
                    })}
                  </div>
                </>
              ) : (
                <div className="my-8 text-center">
                  <p className="text-lg text-gray-600">
                    {t('ご利用可能なテーマがありません。')}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {themesQuery.data && themesQuery.data.length > 0 ? (
          <div className="flex items-center justify-center pb-8 md:h-full">
            <div className="w-full max-w-6xl">
              {/* 全テーマ検索ボタン */}
              <div className="flex justify-center">
                <div className="w-full">
                  <ThemeSearchLink
                    className="flex w-full items-center justify-center space-x-5 rounded-tr-xl bg-white/90 p-4 text-xl font-medium text-gray-800 backdrop-blur-xl transition-colors duration-200 hover:bg-gray-100"
                    underline="hover"
                  >
                    <img
                      src={categoryAllIconImage}
                      alt={t('すべてのテーマ')}
                      className="size-8"
                    />
                    <span>{t('テーマ横断検索')}</span>
                  </ThemeSearchLink>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <div className="flex items-center justify-center p-4 md:h-full">
          {/* ConnectDotsのタグ検索メニュー */}
          <ConnectDotsThemesMenu />
        </div>
      </div>
    </Layout>
  );
};
